/**
 * Enum representing the different types of tags that can be used in the search bar form.
 *
 * @enum {string}
 * @property {string} RECOMMENDED_LOCATIONS - Tag for recommended locations.
 * @property {string} DRIVER_LICENSE_INFO - Tag for driver license information.
 * @property {string} NONE - Represents the absence of a tag.
 */
export var TYPE_TAG;
(function (TYPE_TAG) {
    TYPE_TAG["RECOMMENDED_LOCATIONS"] = "recommendedLocations";
    TYPE_TAG["DRIVER_LICENSE_INFO"] = "driverLicenseInfo";
    TYPE_TAG["NONE"] = "";
})(TYPE_TAG || (TYPE_TAG = {}));
